export const AccountStatus = {
    READY: 'READY',
    OVERDUE: 'OVERDUE'
};
